import { useFloatingEditorState } from '../hooks/useFloatingEditorState';
import { AsyncComposeEditor } from './AsyncComposeEditor';
import { FloatingComposeEditorWrapper } from './FloatingComposeEditorWrapper';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { JUPITER_LAYER } from 'foundations-components/transitional/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingContainer = styled.div.withConfig({
  displayName: "ClassicFloatingComposeEditor__FloatingContainer",
  componentId: "sc-3s6e3u-0"
})(["width:600px;bottom:0;position:fixed;right:110px;z-index:", ";.ProsemirrorInbox__inbox{min-height:373px !important;}"], JUPITER_LAYER);
export const ClassicFloatingComposeEditor = ({
  associations,
  onSend = () => {},
  inboxId,
  renderExistingFileSelect,
  useWhatsAppCompose,
  defaultMessageValue
}) => {
  const {
    isOpen,
    close
  } = useFloatingEditorState();
  if (isOpen) {
    return /*#__PURE__*/_jsx(FloatingContainer, {
      children: /*#__PURE__*/_jsx(Flex, {
        paddingInline: "400",
        children: /*#__PURE__*/_jsx(AsyncComposeEditor, {
          associations: associations,
          onClose: close,
          onSend: onSend,
          onSendStart: close,
          inboxId: inboxId,
          useWhatsAppCompose: useWhatsAppCompose,
          renderExistingFileSelect: renderExistingFileSelect,
          StyledWrapper: FloatingComposeEditorWrapper,
          defaultMessageValue: defaultMessageValue
        })
      })
    });
  }
  return null;
};
ClassicFloatingComposeEditor.displayName = 'ClassicFloatingComposeEditor';